export default "__VITE_ASSET__Bjj2Gav0__"